import { useTheme } from "@emotion/react";
import {
  AccessAlarmOutlined,
  AccessTime,
  Block,
  ChatBubbleOutline,
  ClearOutlined,
  UpdateOutlined,
} from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  Divider,
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import useStyles from "./styles";

const ModalConfigSla = ({
  open,
  onClose,
  loading,
  configSla,
  isEdit,
  setIsEdit,
  editEtapas,
  setEditEtapas,
  handleSave,
  handleCancel,
  converterMinutos,
  formtEditConfigSla,
}) => {
  const theme = useTheme();
  const styles = useStyles(theme);

  // Estado para controlar o tipo de configuração selecionada por etapa
  // 1 = Tratamento de SLA Excedido, 2 = Tratamento de Tempo de Atualização
  const [configTipo, setConfigTipo] = useState({});

  const handleTipoChange = (id, value) => {
    setConfigTipo((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleHourChange = (id, value) => {
    const numericValue = value.replace(/\D/g, "");
    setEditEtapas((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        horas: numericValue === "" ? "" : Number(numericValue),
      },
    }));
  };

  const handleHourTicketChange = (id, value) => {
    const numericValue = value.replace(/\D/g, "");
    setEditEtapas((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        horasIdle: numericValue === "" ? "" : Number(numericValue),
      },
    }));
  };

  const handleActionChange = (id, action) => {
    if (action === 0) {
      action = null;
    }

    setEditEtapas((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        action,
      },
    }));
  };

  const handleActionTicketChange = (id, action) => {
    if (action === 0) {
      action = null;
    }

    setEditEtapas((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        actionIdle: action,
      },
    }));
  };

  const handleTimeActionChange = (id, time) => {
    setEditEtapas((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        timeAction: time,
      },
    }));
  };

  const handleTimeActionTicketChange = (id, time) => {
    setEditEtapas((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        timeActionIdle: time,
      },
    }));
  };

  const handleMinuteChange = (id, value) => {
    let numericValue = value.replace(/\D/g, "");
    if (Number(numericValue) > 59) numericValue = "59";

    setEditEtapas((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        minutos: numericValue === "" ? "" : Number(numericValue),
      },
    }));
  };

  const handleMinuteTicketChange = (id, value) => {
    let numericValue = value.replace(/\D/g, "");
    if (Number(numericValue) > 59) numericValue = "59";

    setEditEtapas((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        minutosIdle: numericValue === "" ? "" : Number(numericValue),
      },
    }));
  };

  const handleCancelar = () => {
    setIsEdit(false);
    setEditEtapas(formtEditConfigSla(configSla));
  };

  const onlyNumbersKeyDown = (e) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];
    if (
      !/^[0-9]$/.test(e.key) &&
      !allowedKeys.includes(e.key) &&
      !e.ctrlKey &&
      !e.metaKey
    ) {
      e.preventDefault();
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={styles.modalConfigSla}>
        {loading ? (
          <Box sx={styles.boxLoadingSla}>
            <CircularProgress size={30} color="secondary" />
          </Box>
        ) : (
          <>
            {/* Header */}
            <Box sx={styles.BoxExitModalConfigSla}>
              <IconButton onClick={onClose}>
                <ClearOutlined />
              </IconButton>
            </Box>

            <Box sx={styles.boxTitleModalConfigSla}>
              <Box sx={{ p: 4 }}>
                <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                  Configuração de SLA por etapa
                </Typography>
              </Box>
            </Box>

            {/* Listagem de Etapas */}
            <Paper variant="outlined" sx={styles.paperItensConfigSla}>
              {Array.isArray(configSla) &&
                configSla.map((sla, index) => {
                  const etapaId = sla.idFluxoAtendimentoEtapa || index;
                  const currentTipo = configTipo[etapaId] || 1;

                  const currentHourValue =
                    currentTipo === 1
                      ? (editEtapas?.[etapaId]?.horas ??
                        converterMinutos(sla?.time)?.hora ??
                        "")
                      : (editEtapas?.[etapaId]?.horasIdle ??
                        converterMinutos(sla?.timeIdle)?.hora ??
                        "");

                  const currentMinuteValue =
                    currentTipo === 1
                      ? (editEtapas?.[etapaId]?.minutos ??
                        converterMinutos(sla?.time)?.minuto ??
                        "")
                      : (editEtapas?.[etapaId]?.minutosIdle ??
                        converterMinutos(sla?.timeIdle)?.minuto ??
                        "");

                  const currentActionValue =
                    currentTipo === 1
                      ? editEtapas?.[etapaId]?.action || 0
                      : editEtapas?.[etapaId]?.actionIdle || 0;

                  const currentTimeActionValue =
                    currentTipo === 1
                      ? (editEtapas?.[etapaId]?.timeAction ??
                        sla?.timeAction ??
                        5)
                      : (editEtapas?.[etapaId]?.timeActionIdle ??
                        sla?.timeActionIdle ??
                        5);

                  return (
                    <Paper
                      key={etapaId}
                      variant="outlined"
                      sx={{
                        ...styles.paperEtapaConfigSla,
                        borderLeft: `8px solid ${
                          theme?.palette?.colors?.[sla?.color]?.medium
                        }`,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          alignItems: "center",
                        }}
                      >
                        <Box sx={{ flex: 1, pr: 2 }}>
                          <Typography sx={{ fontWeight: "bold" }}>
                            {sla?.descricao} {sla?.idEtapa}
                          </Typography>
                        </Box>
                      </Box>

                      <Divider sx={{ margin: "10px 0" }} />

                      {/* Ações de Transbordo/Tratamento */}
                      <Box sx={{ width: "100%" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: 1,
                            gap: 2,
                          }}
                        >
                          {/* SELECT TIPO DE CONFIGURAÇÃO */}
                          <FormControl
                            variant="outlined"
                            size="small"
                            sx={{ minWidth: 280 }}
                          >
                            <Select
                              value={currentTipo}
                              onChange={(e) =>
                                handleTipoChange(etapaId, e.target.value)
                              }
                              startAdornment={
                                <Box sx={styles.boxSelectConfigSla}>
                                  {currentTipo === 1 ? (
                                    <AccessAlarmOutlined fontSize="small" />
                                  ) : (
                                    <UpdateOutlined fontSize="small" />
                                  )}
                                </Box>
                              }
                              renderValue={(selected) => {
                                if (selected === 1)
                                  return "Tratamento de SLA Excedido";
                                if (selected === 2)
                                  return "Tratamento de ticket inativo";
                                return "";
                              }}
                              sx={{
                                ...styles.selectConfig,
                                "& .MuiSelect-select": {
                                  paddingTop: "6px",
                                  paddingBottom: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: isEdit ? "pointer" : "default",
                                },
                                backgroundColor: isEdit
                                  ? "transparent"
                                  : theme?.palette?.action?.hover,
                                transition: "all 0.2s ease",
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  borderColor: isEdit
                                    ? theme?.palette?.primary?.main
                                    : undefined,
                                },
                              }}
                            >
                              <MenuItem
                                value={1}
                                sx={{ typography: "body2", gap: 1 }}
                              >
                                <AccessAlarmOutlined
                                  fontSize="small"
                                  sx={{ opacity: 0.7 }}
                                />
                                Tratamento de SLA excedido
                              </MenuItem>
                              <MenuItem
                                value={2}
                                sx={{ typography: "body2", gap: 1 }}
                              >
                                <UpdateOutlined
                                  fontSize="small"
                                  sx={{ opacity: 0.7 }}
                                />
                                Tratamento de ticket inativo
                              </MenuItem>
                            </Select>
                          </FormControl>

                          <Box sx={styles.boxTimeConfigSla}>
                            <Typography sx={styles.refConfigSla}>
                              Tempo máximo:
                            </Typography>

                            {isEdit ? (
                              <Paper
                                variant="outlined"
                                sx={styles.containerPaperEditConfigSla}
                              >
                                {/* Inputs de Horas */}
                                <Box sx={styles.boxEditConfigSla}>
                                  <AccessTime
                                    sx={{ fontSize: 14, opacity: 0.7 }}
                                  />
                                  <TextField
                                    type="text"
                                    variant="outlined"
                                    size="small"
                                    value={currentHourValue}
                                    onKeyDown={onlyNumbersKeyDown}
                                    onChange={(e) =>
                                      currentTipo === 1
                                        ? handleHourChange(
                                            etapaId,
                                            e.target.value,
                                          )
                                        : handleHourTicketChange(
                                            etapaId,
                                            e.target.value,
                                          )
                                    }
                                    inputProps={{
                                      inputMode: "numeric",
                                      style: { padding: "4px 2px" },
                                    }}
                                    sx={styles.textFieldEditConfigSla}
                                  />
                                  <Box sx={styles.boxTextConfigSla}>h</Box>
                                </Box>

                                <Box sx={styles.boxTextConfigSla}>:</Box>

                                {/* Inputs de Minutos */}
                                <Box sx={styles.boxEditConfigSla}>
                                  <TextField
                                    type="text"
                                    variant="outlined"
                                    value={currentMinuteValue}
                                    onKeyDown={onlyNumbersKeyDown}
                                    onChange={(e) =>
                                      currentTipo === 1
                                        ? handleMinuteChange(
                                            etapaId,
                                            e.target.value,
                                          )
                                        : handleMinuteTicketChange(
                                            etapaId,
                                            e.target.value,
                                          )
                                    }
                                    inputProps={{
                                      inputMode: "numeric",
                                      style: { padding: "4px 2px" },
                                    }}
                                    sx={styles.textFieldEditConfigSla}
                                  />
                                  <Box sx={styles.boxTextConfigSla}>min</Box>
                                </Box>
                              </Paper>
                            ) : (
                              <Typography
                                sx={{
                                  fontWeight: "bold",
                                  fontSize: "12px",
                                  opacity: 0.8,
                                }}
                              >
                                {currentTipo === 1
                                  ? converterMinutos(sla?.time)?.text
                                  : converterMinutos(sla?.timeIdle)?.text}
                              </Typography>
                            )}
                          </Box>
                        </Box>

                        {/* INPUTS DE AÇÃO (Dinâmico) */}
                        <FormControl
                          component="fieldset"
                          sx={{ width: "100%" }}
                          disabled={!isEdit}
                        >
                          <RadioGroup
                            value={currentActionValue}
                            name={`action-group-${etapaId}`}
                            onChange={(e) =>
                              currentTipo === 1
                                ? handleActionChange(etapaId, e.target.value)
                                : handleActionTicketChange(
                                    etapaId,
                                    e.target.value,
                                  )
                            }
                          >
                            <Paper variant="outlined" sx={styles.paperAction}>
                              <FormControlLabel
                                value={0}
                                control={<Radio size="small" />}
                                label={
                                  <Box sx={{ ml: 1 }}>
                                    <Typography
                                      variant="subtitle2"
                                      sx={{ fontWeight: "bold" }}
                                    >
                                      Nenhuma Ação
                                    </Typography>
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                    >
                                      O sistema não aplicará restrições ou
                                      alertas visuais ao exceder o tempo.
                                    </Typography>
                                  </Box>
                                }
                                sx={{ margin: 0, width: "100%" }}
                              />
                            </Paper>

                            <Paper
                              variant="outlined"
                              sx={{ ...styles.paperAction }}
                            >
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <FormControlLabel
                                  value={1}
                                  control={<Radio size="small" />}
                                  label={
                                    <Box sx={{ ml: 1 }}>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                        }}
                                      >
                                        <ChatBubbleOutline
                                          fontSize="small"
                                          color="primary"
                                        />
                                        <Typography
                                          variant="subtitle2"
                                          sx={{ fontWeight: "bold" }}
                                        >
                                          Exibir Pop-up
                                        </Typography>
                                      </Box>
                                      <Typography
                                        variant="caption"
                                        color="text.secondary"
                                      >
                                        Mostra uma mensagem flutuante ao usuário
                                        a cada {currentTimeActionValue}{" "}
                                        {/* ✨ Alterado para a variável dinâmica */}
                                        minutos sem interromper o fluxo.
                                      </Typography>
                                    </Box>
                                  }
                                  sx={{ margin: 0, width: "100%" }}
                                />
                                <Box sx={{ ...styles.boxTimeConfigSla }}>
                                  <Collapse
                                    in={Number(currentActionValue) === 1}
                                  >
                                    <Box sx={{ ...styles.boxTimeConfigSla }}>
                                      <Typography sx={styles.refConfigSla}>
                                        Pop-up a cada:
                                      </Typography>

                                      <Paper
                                        variant="outlined"
                                        sx={styles.containerPaperEditConfigSla}
                                      >
                                        <Box sx={styles.boxEditConfigSla}>
                                          <TextField
                                            type="text"
                                            variant="outlined"
                                            disabled={!isEdit}
                                            value={currentTimeActionValue} // ✨ Alterado para a variável dinâmica
                                            onKeyDown={onlyNumbersKeyDown}
                                            onChange={(e) => {
                                              e.stopPropagation();
                                              // ✨ Condicional dinâmica aplicada no onChange do input
                                              currentTipo === 1
                                                ? handleTimeActionChange(
                                                    etapaId,
                                                    Number(e.target.value),
                                                  )
                                                : handleTimeActionTicketChange(
                                                    etapaId,
                                                    Number(e.target.value),
                                                  );
                                            }}
                                            inputProps={{
                                              inputMode: "numeric",
                                              style: { padding: "4px 2px" },
                                            }}
                                            sx={styles.textFieldEditConfigSla}
                                          />
                                          <Box sx={styles.boxTextConfigSla}>
                                            min
                                          </Box>
                                        </Box>
                                      </Paper>
                                    </Box>
                                  </Collapse>
                                </Box>
                              </Box>
                            </Paper>

                            <Paper variant="outlined" sx={styles.paperAction}>
                              <FormControlLabel
                                value={2}
                                control={<Radio size="small" />}
                                label={
                                  <Box sx={{ ml: 1 }}>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                      }}
                                    >
                                      <Block fontSize="small" color="error" />
                                      <Typography
                                        variant="subtitle2"
                                        sx={{ fontWeight: "bold" }}
                                      >
                                        Bloquear Tela
                                      </Typography>
                                    </Box>
                                    <Typography
                                      variant="caption"
                                      color="text.secondary"
                                    >
                                      Impedirá a interação com o fluxo até que o
                                      atendimento seja{" "}
                                      {configTipo[etapaId] === 1
                                        ? "encaminhado ou encerrado"
                                        : "editado ou encerrado"}
                                      .
                                    </Typography>
                                  </Box>
                                }
                                sx={{ margin: 0, width: "100%" }}
                              />
                            </Paper>
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </Paper>
                  );
                })}
            </Paper>

            {/* Footer Buttons */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2 }}>
              <Box sx={{ display: "flex", gap: 1 }}>
                {isEdit ? (
                  <>
                    <Button onClick={handleCancelar} size="small">
                      Cancelar
                    </Button>
                    <Button
                      onClick={handleSave}
                      size="small"
                      variant="contained"
                    >
                      Salvar
                    </Button>
                  </>
                ) : (
                  <Button
                    onClick={() => setIsEdit(true)}
                    size="small"
                    variant="contained"
                  >
                    Editar
                  </Button>
                )}
              </Box>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default ModalConfigSla;
